import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import BootstrapVue from 'bootstrap-vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faFileDownload,
  faTrash,
  faEdit,
  faPrint,
  faBold,
  faItalic,
  faStrikethrough,
  faUnderline,
  faCode,
  faParagraph,
  faHeading,
  faListUl,
  faListOl,
  faQuoteLeft,
  faCodeBranch,
  faMinus,
  faUndo,
  faRedo
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {AuthorizePlugin, authorizeRoute} from './services/Authorize';
import {FormatterPlugin} from '@/services/inputTools';

library.add(
  faFileDownload,
  faTrash,
  faEdit,
  faPrint,
  faBold,
  faItalic,
  faStrikethrough,
  faUnderline,
  faCode,
  faParagraph,
  faHeading,
  faListUl,
  faListOl,
  faQuoteLeft,
  faCodeBranch,
  faMinus,
  faUndo,
  faRedo
  );
Vue.use(BootstrapVue);
import 'bootstrap-vue/dist/bootstrap-vue.css';
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.use(AuthorizePlugin);
Vue.use(FormatterPlugin);

router.beforeEach(authorizeRoute);

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
